import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';

import Collapse from '@material-ui/core/Collapse';

import Close from '@material-ui/icons/Close';

import colors from '../../assets/colors';
import fontSize from '../../assets/fontSize';

const ChipsWrapper = styled.div`
  padding: 0.5rem 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
const Chip = styled.div`
  padding: 0.25rem 0.5rem;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: ${fontSize.medium};
  background-color: ${colors.white};
  border: 2px solid ${colors.greyBorder};
  border-radius: 20px;
  gap: 0.5rem;
`;
const CloseIcon = styled(Close)`
  cursor: pointer;
  font-size: ${fontSize.large};
`;

const CollapsibleChips = props => {
  const { open, type, filterCounts, appliedFilters, handleApplyFilters } =
    props;
  const [mappedFilters, setMappedFilters] = useState([]);

  const handleRemoveFilter = filterToRemove => {
    if (type === 'jobType') {
      const newFilters = appliedFilters.filter(
        filter => filter !== filterToRemove
      );
      handleApplyFilters(type, newFilters);
    }
    if (type === 'employmentType') {
      let filterToRemoveFromArray = filterToRemove;
      if (filterToRemove === 'gig') {
        filterToRemoveFromArray = 'hourly_gig';
      }
      const newFilters = appliedFilters.filter(
        filter => filter !== filterToRemoveFromArray
      );
      handleApplyFilters(type, newFilters);
    }
    if (type === 'location') {
      const newFilters = appliedFilters.filter(
        filter => filter !== filterToRemove.split(' ').join('_').toLowerCase()
      );
      handleApplyFilters(type, newFilters);
    }
  };

  useEffect(() => {
    if (appliedFilters.length > 0 && filterCounts.length > 0) {
      const filters = filterCounts.filter(filter => {
        if (type === 'jobType') return appliedFilters.includes(filter.value);
        if (type === 'employmentType') {
          if (filter.value === 'gig' && appliedFilters.includes('hourly_gig')) {
            return true;
          }
          return appliedFilters.includes(filter.value);
        }
        if (type === 'location') {
          return appliedFilters.includes(
            filter.value.split(' ').join('_').toLowerCase()
          );
        }
        return false;
      });

      setMappedFilters(filters);
    }
  }, [filterCounts, appliedFilters, type]);

  return (
    <Collapse in={open && mappedFilters.length > 0}>
      <ChipsWrapper>
        {mappedFilters.map(filter => {
          return (
            <Chip key={filter.value}>
              <span>
                {filter.title} ({filter.count})
              </span>
              <CloseIcon onClick={() => handleRemoveFilter(filter.value)} />
            </Chip>
          );
        })}
      </ChipsWrapper>
    </Collapse>
  );
};

export default CollapsibleChips;
